import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { DealershipsContainerProps } from "../../../interfaces/containers";
import Concessionaire from "../../../pages/Profile/Concessionaire/Concessionarie";
import { getDealerships, cleanGetDealerships } from "../../../actions/dealerships";

function mapStateToProps(state: DealershipsContainerProps) {
    return {
        user: state.auth.user,
        dealerships: state.profile.dealerships
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        getDealerships,
        cleanGetDealerships
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(Concessionaire);
